import React from 'react';
import { motion } from 'framer-motion';

interface FilterButton {
  id: string;
  label: string;
}

interface AppliedFiltersProps {
  appliedFilters: Record<string, any>;
  filterOptions: FilterButton[];
  removeFilter: (key: string) => void;
  clearAllFilters: () => void;
  isDisabled: boolean;
}

const AppliedFilters: React.FC<AppliedFiltersProps> = ({
  appliedFilters,
  filterOptions,
  removeFilter,
  clearAllFilters,
  isDisabled,
}) => {
  const hasFilters = Object.keys(appliedFilters).length > 0;

  if (!hasFilters) {
    return null;
  }

  return (
    <motion.div
      className="mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <span className="text-sm font-medium text-gray-800 dark:text-gray-200">
          Bộ lọc đã áp dụng:
        </span>
        {Object.entries(appliedFilters).map(([key, value]) => {
          const filterLabel = filterOptions.find((f) => f.id === key)?.label || key;
          return (
            <motion.div
              key={key}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="inline-flex items-center gap-2 bg-white dark:bg-gray-800 px-3 py-1 rounded-full border border-gray-300 dark:border-gray-600 text-sm"
            >
              <span className="text-gray-700 dark:text-gray-300">
                {filterLabel}: <strong>{value}</strong>
              </span>
              <button
                onClick={() => removeFilter(key)}
                disabled={isDisabled}
                className="text-gray-500 hover:text-red-600 dark:hover:text-red-400 transition-colors"
              >
                ✕
              </button>
            </motion.div>
          );
        })}
      </div>
      <button
        onClick={clearAllFilters}
        disabled={isDisabled}
        className="text-sm text-blue-700 dark:text-blue-400 hover:text-blue-900 dark:hover:text-blue-300 font-medium"
      >
        Xóa tất cả bộ lọc
      </button>
    </motion.div>
  );
};

export default AppliedFilters;
